import React from 'react';
import { Skeleton } from '@mui/material';

export const QueryPreviewSkeleton = () => (
    <div className="space-y-3">
        {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="border border-gray-200 rounded-lg p-4">
                <div className="flex items-start gap-3">
                    <div className="flex-1 min-w-0">
                        <div className="flex items-center flex-wrap gap-2 mb-2">
                            <Skeleton variant="text" width={80} height={20} />
                            <Skeleton variant="rounded" width={60} height={20} />
                            <Skeleton variant="rounded" width={50} height={20} />
                            <Skeleton variant="text" width={100} height={20} />
                        </div>

                        <Skeleton variant="text" width="90%" height={24} className="mb-2" />
                        <Skeleton variant="text" width="60%" height={24} className="mb-3" />

                        <div className="flex flex-wrap gap-2 mb-3">
                            {[1, 2, 3].map((tag) => (
                                <Skeleton key={tag} variant="rounded" width={80} height={20} />
                            ))}
                        </div>

                        <div className="flex flex-wrap items-center gap-x-4 gap-y-1 pt-2 border-t border-gray-100">
                            <Skeleton variant="text" width={100} height={16} />
                            <Skeleton variant="text" width={120} height={16} />
                            <Skeleton variant="text" width={80} height={16} />
                        </div>
                    </div>
                    <Skeleton variant="rectangular" width={20} height={20} />
                </div>
            </div>
        ))}
    </div>
);
